
const EntryPatternBuilderMixin = {
  methods: {

    /**
     * 登録パターンの送信パラメータを生成
     * @param orderType { String } オーダー種別
     * @param isShared { Boolean } 事業場共通として利用
     * @return { Object }
     */
    entryPatternParameterBuilder (orderType, isShared= false) {

      let orderMember = {
        order_type: orderType,
        sales_staff: this.nullToBlank(this.order.sales_staff),
        dxe_vote_staff: this.nullToBlank(this.order.dxe_vote_staff),
        repeat_setting: this.nullToBlank(this.order.repeat_setting),
        copy_count: null,
        selected_collected_dates: null,
        driver_instruction: this.nullToBlank(this.order.driver_instruction),
        keyword: this.nullToBlank(this.order.keyword),
        plan_date: null,
        plan_start_time: this.nullToBlank(this.order.preferred_start_time),
        plan_end_time: this.nullToBlank(this.order.preferred_end_time),
        transport_user_id: this.nullToBlank(this.order.transport_user_id),
        transport_user_name: this.nullToBlank(this.order.transport_user_name),
        transportation_id: this.nullToBlank(this.order.transportation_id),
        vehicle_number: this.nullToBlank(this.order.vehicle_number),
        send_save: this.nullToBlank(this.sendSave),
      };
      if (this.order.form_type === 'free_mode') {
        orderMember['not_recorded_sales'] = true;

      } else {
        orderMember['not_recorded_sales'] = this.nullToBlank(this.order.not_recorded_sales);
      }

      let orderCollectionMember = {};

      orderCollectionMember['use_spot_emission_location'] = this.nullToBlank(this.order.use_spot_emission_location);

      if (this.order.form_type === 'master_mode') {
        orderCollectionMember['emission_id'] = this.nullToBlank(this.order.emission_id);
        orderCollectionMember['emission_location_id'] = this.nullToBlank(this.order.emission_location_id);

        if (this.order.use_spot_emission_location && this.order.lock_spot_emission_location) {
          orderCollectionMember['emission_location_id'] = null;
          orderCollectionMember['emission_location_name'] = this.nullToBlank(this.order.emission_location_name);
          orderCollectionMember['emission_location_zip_code'] = this.nullToBlank(this.order.emission_location_zip_code);
          orderCollectionMember['emission_location_prefecture_code'] = this.nullToBlank(this.order.emission_location_prefecture_code);
          orderCollectionMember['emission_location_address_1'] = this.nullToBlank(this.order.emission_location_address_1);
          orderCollectionMember['emission_location_address_2'] = this.nullToBlank(this.order.emission_location_address_2);
          orderCollectionMember['emission_location_address_3'] = this.nullToBlank(this.order.emission_location_address_3);
          orderCollectionMember['emission_location_phone_number'] = this.nullToBlank(this.order.emission_location_phone_number);
        }

        if (isShared) {
          orderCollectionMember['emission_location_id'] = null;
          orderCollectionMember['emission_location_name'] = null;
          orderCollectionMember['emission_location_zip_code'] = null;
          orderCollectionMember['emission_location_prefecture_code'] = null;
          orderCollectionMember['emission_location_address_1'] = null;
          orderCollectionMember['emission_location_address_2'] = null;
          orderCollectionMember['emission_location_address_3'] = null;
          orderCollectionMember['emission_location_phone_number'] = null;
        }

      } else {
        orderCollectionMember['emission_name'] = this.nullToBlank(this.order.emission_name);
        orderCollectionMember['emission_zip_code'] = this.nullToBlank(this.order.emission_zip_code);
        orderCollectionMember['emission_prefecture_code'] = this.nullToBlank(this.order.emission_prefecture_code);
        orderCollectionMember['emission_address_1'] = this.nullToBlank(this.order.emission_address_1);
        orderCollectionMember['emission_address_2'] = this.nullToBlank(this.order.emission_address_2);
        orderCollectionMember['emission_address_3'] = this.nullToBlank(this.order.emission_address_3);
        orderCollectionMember['emission_phone_number'] = this.nullToBlank(this.order.emission_phone_number);
        orderCollectionMember['emission_location_name'] = this.nullToBlank(this.order.emission_location_name);
        orderCollectionMember['emission_location_zip_code'] = this.nullToBlank(this.order.emission_location_zip_code);
        orderCollectionMember['emission_location_prefecture_code'] = this.nullToBlank(this.order.emission_location_prefecture_code);
        orderCollectionMember['emission_location_address_1'] = this.nullToBlank(this.order.emission_location_address_1);
        orderCollectionMember['emission_location_address_2'] = this.nullToBlank(this.order.emission_location_address_2);
        orderCollectionMember['emission_location_address_3'] = this.nullToBlank(this.order.emission_location_address_3);
        orderCollectionMember['emission_location_phone_number'] = this.nullToBlank(this.order.emission_location_phone_number);

      }
      orderCollectionMember['form_type'] = this.nullToBlank(this.order.form_type);
      orderCollectionMember['manifest_type'] = this.nullToBlank(this.order.manifest_type);
      orderCollectionMember['deliver_staff'] = this.nullToBlank(this.order.deliver_staff);
      orderCollectionMember['register_staff'] = this.nullToBlank(this.order.register_staff);
      orderCollectionMember['past_manifest'] = this.nullToBlank(this.order.past_manifest);

      const manifestMembers = [];
      this.order.manifests.forEach((manifest, index) => {

        if (!manifest._destroy) {
          let manifestMember = {}
          manifestMember[`sales_item_price_code`] = this.nullToBlank(manifest.sales_item_price_code);
          /* 連絡番号1 */
          manifestMember[`contact_number_1`] = this.nullToBlank(manifest.contact_number_1);
          /* 連絡番号2 */
          manifestMember[`contact_number_2`] = this.nullToBlank(manifest.contact_number_2);
          /* 連絡番号3 */
          manifestMember[`contact_number_3`] = this.nullToBlank(manifest.contact_number_3);

          /* 取扱品目 */
          manifestMember[`item_id`] = this.nullToBlank(manifest.item_id);
          manifestMember['item_type'] = this.orderType === 'general' ? 'GeneralItem' : 'Item';

          /* 廃棄物の名称 */
          manifestMember[`waste_name`] = this.nullToBlank(manifest.waste_name);

          /* マニフェスト番号 */
          if (this.order.manifest_type !== 'dxe_form' || manifest.includeNonSubscribeTrader || this.orderType === 'general') {
            manifestMember[`manifest_no`] = this.nullToBlank(manifest.manifest_no);
          }
          /* 荷姿の数量 */
          manifestMember[`packing_quantity`] = this.nullToBlank(manifest.packing_quantity);
          /* 荷姿 */
          manifestMember[`packing_id`] = this.nullToBlank(manifest.packing_id);
          /* 数量 */
          manifestMember[`quantity`] = this.nullToBlank(manifest.quantity);
          /* 数量単位 */
          manifestMember[`quantity_unit_id`] = this.nullToBlank(manifest.quantity_unit_id);
          /* 数量の確定者 */
          manifestMember[`quantity_confirm_id`] = this.nullToBlank(manifest.quantity_confirm_id);
          /* 有害物質1 */
          manifestMember[`hazardous_substance_1_id`] = this.nullToBlank(manifest.hazardous_substance_1_id);
          /* 有害物質2 */
          manifestMember[`hazardous_substance_2_id`] = this.nullToBlank(manifest.hazardous_substance_2_id);
          /* 有害物質3 */
          manifestMember[`hazardous_substance_3_id`] = this.nullToBlank(manifest.hazardous_substance_3_id);
          /* 有害物質4 */
          manifestMember[`hazardous_substance_4_id`] = this.nullToBlank(manifest.hazardous_substance_4_id);
          /* 有害物質5 */
          manifestMember[`hazardous_substance_5_id`] = this.nullToBlank(manifest.hazardous_substance_5_id);
          /* 有害物質6 */
          manifestMember[`hazardous_substance_6_id`] = this.nullToBlank(manifest.hazardous_substance_6_id);
          /* 運搬ルート */
          manifestMember[`transport_route_id`] = this.nullToBlank(manifest.transport_route_id);
          /* マニフェスト区分 */
          /* 処分方法 */
          manifestMember[`disposal_method_id`] = this.nullToBlank(manifest.disposal_method_id);
          /* 基準重量 */
          manifestMember[`standard_quantity_type`] = this.nullToBlank(manifest.standard_quantity_type);
          /* 処分場処理方法 */
          manifestMember[`recycle_disposer_disposal_method_id`] = this.nullToBlank(manifest.recycle_disposer_disposal_method_id);
          /* 備考１ */
          manifestMember[`note_1`] = this.nullToBlank(manifest.note_1);
          /* 備考２ */
          manifestMember[`note_2`] = this.nullToBlank(manifest.note_2);
          /* 備考３ */
          manifestMember[`note_3`] = this.nullToBlank(manifest.note_3);
          /* 備考４ */
          manifestMember[`note_4`] = this.nullToBlank(manifest.note_4);
          /* 備考５ */
          manifestMember[`note_5`] = this.nullToBlank(manifest.note_5);

          /* 運搬担当者ID */
          manifestMember[`transport_user_id`] = this.nullToBlank(this.order.transport_user_id);
          /* 運搬担当者 */
          manifestMember[`transport_user_name`] = this.nullToBlank(this.order.transport_user_name);
          /* 運搬方法 */
          manifestMember[`transportation_id`] = this.nullToBlank(this.order.transportation_id);
          /* 車両番号 */
          manifestMember[`vehicle_number`] = this.nullToBlank(this.order.vehicle_number);

          /* マニフェスト検索キーワード */
          if (manifest.manifest_search_keywords) {
            manifestMember["manifest_search_keywords_attributes"] = [
              {"keyword": this.nullToBlank(manifest.manifest_search_keywords.keyword),}
            ]
          }
          manifestMembers.push(manifestMember)
        }
      });

      return {
        order: orderMember,
        order_collection: orderCollectionMember,
        manifests: manifestMembers
      }
    },

  },

}
export default EntryPatternBuilderMixin;
